/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import { Label, MultiColumnList, NoValue } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import useData from '../../../../hooks/useData';
import { getCustomFieldValue } from '../../../../utils/utils';

const noValue = <NoValue />;

function RepeatableFieldView({ fieldValues, locale, data }) {
  const dataSource = useData();

  const {
    name: fieldName,
    label,
    schema,
    type,
    dataOptionsSource,
    fieldDataOption,
    singularLabel,
  } = fieldValues;
  const fieldLabel = label.find((field) => field.locale === locale)?.value;
  const fieldValue =
    schema === 'default'
      ? data[fieldName]
      : getCustomFieldValue(fieldName, data, []);

  const contentData = fieldValue?.length
    ? fieldValue?.map((field) => {
        return { name: field };
      })
    : [{}];

  const getItemValue = (item) => {
    const src = dataSource[dataOptionsSource];
    const dataSourceValue = src?.find(
      (source) => source.id === item.name,
    )?.name;
    const fieldDataOptionValue = fieldDataOption
      .find((field) => field.value === item.name)
      ?.label.find((field) => field.locale === locale)?.value;
    const value = schema === 'default' ? dataSourceValue : fieldDataOptionValue;

    return (
      <>
        {value ? (
          <FormattedMessage
            id={`ui-inventory.${dataOptionsSource}.name.${value}`}
            defaultMessage={value}
          />
        ) : (
          <NoValue />
        )}
      </>
    );
  };

  const getFormatter = () => {
    if (type === 'select') {
      return { name: (item) => getItemValue(item) || <NoValue /> };
    }

    return { name: (item) => item.name || noValue };
  };

  const getColumnMapping = () => {
    const nameFieldMapping = singularLabel.find(
      (field) => field.locale === locale,
    )?.value;
    return { name: nameFieldMapping };
  };

  return (
    <>
      <Label>{fieldLabel}</Label>
      <MultiColumnList
        interactive={false}
        contentData={contentData}
        visibleColumns={['name']}
        columnMapping={getColumnMapping()}
        formatter={getFormatter()}
        emptyMessage={<NoValue />}
      />
    </>
  );
}

RepeatableFieldView.propTypes = {
  fieldValues: PropTypes.object,
  locale: PropTypes.string,
  data: PropTypes.object,
};

export default RepeatableFieldView;
